import {Injectable, Type} from '@angular/core';

@Injectable()
export class WidgetType {
  constructor(public type: Type<any>, public name, public active: boolean = false, public index: number = 0) {
  }

  toggleActive() {
    return this.active = !this.active;
  }

  activate() {
    this.active = true;
  }

  deactivate() {
    this.active = false;
  }
}
